module.exports = __webpack_public_path__ + "ce93eab3ed42616b9a5c187a34202efa.png";